module.exports = __webpack_public_path__ + "static/media/Noproject1.68fecb08.png";